module.exports = __webpack_public_path__ + "img/drivers-6.jpg";